<div class="row padding-row backgrounDColor">

  <div class="col s12 m4 l4">
    <div class="card">
      <div class="card-content black-text">
        <div class="center">
          <fa-icon [icon]="reportIcon" size="7x"></fa-icon>
        </div>
        <p class="center">Area Units Reports
        </p>
      </div>
      <div class="card-action center">
        
        <a class="waves-effect waves-light btn-small btn-border" routerLink="/teacher/area-unit-reports/68"
          *ngIf="currentUser.memberstatus === 'ivsaadmin'">IVSA </a>

      </div>
    </div>
  </div>

</div>